<script setup lang="ts">
import { ref } from 'vue'

withDefaults(
  defineProps<{
    sidebarOpen?: boolean
  }>(),
  { sidebarOpen: false },
)

const emit = defineEmits<{
  closeSidebar: []
}>()

function closeFinder() {
  emit('closeSidebar')
}

const statut = ref<string | undefined>('Actif')
const statutItems = [
  'Actif',
  'Expertise',
  'Loué',
  'Vendu',
  'En attente de mandat',
  'Vente suspendue',
]

const owner = ref<string | undefined>(undefined)
const ownerItems = [
  'Jean Dupont',
  'Nathalie Martin',
  'Pierre Durand',
  'Sophie Bernard',
  'Paul Morel',
  'Julie Petit',
  'Luc Leroy',
  'Marie Dubois',
]

const city = ref<string | undefined>(undefined)
const cityItems = [
  'Paris',
  'Lyon',
  'Marseille',
  'Toulouse',
  'Bordeaux',
  'Brive-la-Gaillarde',
  'Lille',
  'Nantes',
  'Strasbourg',
  'Montpellier',
  'Nice',
  'Pompadour',
]

const reference = ref('')

const transaction = ref<string | undefined>('Vente')
const transactionItems = ['Vente', 'Location', 'Viager']

const category = ref<string | undefined>(undefined)
const categoryItems = ['Maison', 'Appartement', 'Terrain', 'Local commercial']
const surfaceMin = ref('')
const priceMax = ref('')

function onSubmit() {
  closeFinder()
}

function onReset() {
  statut.value = undefined
  owner.value = undefined
  city.value = undefined
  reference.value = ''
  transaction.value = undefined
  category.value = undefined
  surfaceMin.value = ''
  priceMax.value = ''
}
</script>

<template>
  <Transition name="fade">
    <div
      v-if="sidebarOpen"
      class="fixed inset-0 z-50 flex w-screen items-start justify-center overflow-y-auto bg-black/90 pt-12 px-4 xl:hidden"
      @click.self="closeFinder"
    >
      <div class="bg-white rounded-lg shadow-lg w-full max-w-sm relative max-h-[90vh] overflow-hidden flex flex-col">
        <button
          aria-label="Fermer"
          class="absolute top-3 right-3 z-10 p-1"
          @click="closeFinder"
        >
          <Icon name="lucide:x" class="text-xl" />
        </button>

        <SearchSidebar
          class="w-full max-h-none static"
          cancel-label="Réinitialiser"
          @submit="onSubmit"
          @cancel="onReset"
        >
          <UFormField label="Statut">
            <USelectMenu v-model="statut" :items="statutItems" class="w-full" />
          </UFormField>

          <UFormField label="Propriétaire">
            <USelectMenu
              v-model="owner"
              :items="ownerItems"
              placeholder="Rechercher un propriétaire"
              class="w-full"
            />
          </UFormField>

          <UFormField label="Localité">
            <USelectMenu
              v-model="city"
              :items="cityItems"
              placeholder="Rechercher une ville"
              icon="i-lucide-locate-fixed"
              class="w-full"
            />
          </UFormField>

          <UFormField label="Référence">
            <UInput
              v-model="reference"
              placeholder="Réf."
              icon="i-lucide-refresh-ccw"
              class="w-full"
            />
          </UFormField>

          <UFormField label="Transaction">
            <USelectMenu v-model="transaction" :items="transactionItems" class="w-full" />
          </UFormField>

          <template #more>
            <UFormField label="Catégorie">
              <USelectMenu v-model="category" :items="categoryItems" class="w-full" />
            </UFormField>

            <UFormField label="Surface min.">
              <UInput v-model="surfaceMin" placeholder="m²" class="w-full" />
            </UFormField>

            <UFormField label="Prix max.">
              <UInput v-model="priceMax" placeholder="€" class="w-full" />
            </UFormField>
          </template>
        </SearchSidebar>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
